module.exports = __webpack_public_path__ + "static/media/DSCF9012.7b203f65.JPG";